/* ==========================================================================
   v2-compte.js — la logique de la page « Mon compte ». Cree le 2026-08-14.
   --------------------------------------------------------------------------
   CE FICHIER NE VA CHERCHER AUCUNE DONNEE. Les plans sont deja rendus en
   Liquid dans `snippets/v2-p-compte.liquid` ; ce script ne fait que lire les
   `data-*` poses sur chaque carte et piloter le panneau de gestion.

   IL NE PARLE PAS A v2-booking.js. Celui-ci est une IIFE : `planActif()` et
   `estAbonne()` ne sont pas exportees, et de toute facon ce fichier est tenu
   par une autre session. Aucune frontiere n'est franchie ici.

   CE QU'IL FAIT VRAIMENT : il conduit un entonnoir de retention. Le principe
   vole a Subscribee, et c'est le seul detail qui compte — L'OFFRE DE SAUVETAGE
   REPOND AU MOTIF DONNE. Un client qui part parce que c'est trop cher et un
   client qui part parce qu'il demenage ne recoivent pas la meme phrase : au
   premier on propose un rythme moins frequent, au second on souhaite bonne
   route. Proposer un rabais a quelqu'un qui demenage, c'est se faire dire non
   deux fois.

   L'envoi passe par le formulaire `contact` de Shopify (`#cptForm`). Rien
   n'est ecrit sur le plan : un humain lit le courriel et execute. Voir le
   commentaire d'en-tete de `v2-p-compte.liquid` pour le pourquoi.
   ========================================================================== */
(function () {
  'use strict';

  var modale = document.getElementById('cptModale');
  var ecran = document.getElementById('cptEcran');
  var form = document.getElementById('cptForm');
  if (!modale || !ecran) return;

  var planCourant = null;   // la carte <article> visee par le panneau
  var motifChoisi = null;   // la cle du motif d'annulation en cours
  var dernierFocus = null;

  /* ---- Le bandeau de retour apres envoi -------------------------------
     Shopify redirige vers la meme page avec `?contact_posted=true`. On
     nettoie ensuite l'URL : sans ca, un rafraichissement rejoue le bandeau
     et le client croit avoir envoye deux demandes.                       */
  if (/[?&]contact_posted=true/.test(window.location.search)) {
    var recu = document.getElementById('cptRecu');
    if (recu) {
      recu.hidden = false;
      recu.focus();
      recu.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }

  /* ---- Outils ---------------------------------------------------------- */

  function ech(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
              'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  // Une date AAAA-MM-JJ se lit en morceaux, jamais par `new Date('2026-09-01')` :
  // cette forme est interpretee en UTC et recule d'un jour a l'est de Greenwich.
  function enClair(iso) {
    if (!iso || iso.length < 10) return '';
    var m = iso.split('-');
    return parseInt(m[2], 10) + ' ' + MOIS[parseInt(m[1], 10) - 1] + ' ' + m[0];
  }

  function dansNJours(n) {
    var d = new Date();
    d.setDate(d.getDate() + n);
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var jj = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + mm + '-' + jj;
  }

  function nomDuPlan() {
    return planCourant ? (planCourant.getAttribute('data-nom') || 'votre plan') : 'votre plan';
  }

  function estAbonnement() {
    return planCourant && (planCourant.getAttribute('data-genre') || '') === 'abonnement';
  }

  // Le mot qui designe un allegement, pour CE produit. « Aux 2 mois » dit a un
  // abonne aux 6 mois serait une augmentation.
  function plusEspace() {
    return estAbonnement() ? 'aux 6 mois' : 'aux 2 mois';
  }

  /* Une date deja passee ne se saute pas et ne se propose pas.
     Le Liquid, lui, la marque « Passage a replanifier » (v2-p-compte.liquid) :
     sans ce filtre, la carte disait « a replanifier » pendant que le panneau
     proposait de sauter cette meme date, et l'atelier recevait une demande de
     retrait sur un passage vieux de six semaines. */
  function prochainUtile() {
    var d = planCourant ? (planCourant.getAttribute('data-prochain') || '') : '';
    return (d && d >= dansNJours(0)) ? d : '';
  }

  /* ---- Ouverture / fermeture du panneau -------------------------------- */

  function ouvrir(carte) {
    planCourant = carte;
    motifChoisi = null;
    dernierFocus = document.activeElement;
    modale.hidden = false;
    document.body.style.overflow = 'hidden';
    montrer('menu');
  }

  function fermer() {
    modale.hidden = true;
    document.body.style.overflow = '';
    ecran.innerHTML = '';
    planCourant = null;
    motifChoisi = null;
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var gerer = e.target.closest('.cpt-gerer');
    if (gerer) {
      var carte = gerer.closest('.cpt-plan');
      if (carte) ouvrir(carte);
      return;
    }
    if (e.target.closest('[data-cpt-fermer]')) fermer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modale.hidden) fermer();
  });

  /* ---- Les ecrans ------------------------------------------------------
     Chaque ecran rend son HTML dans #cptEcran et branche ses boutons. On
     garde le meme conteneur d'un ecran a l'autre pour que le `hidden` et le
     focus n'aient qu'un seul proprietaire.                                */

  function montrer(nom) {
    var f = ECRANS[nom];
    if (!f) return;
    ecran.innerHTML = f();
    var premier = ecran.querySelector('h3');
    if (premier) { premier.id = 'cptModaleTitre'; premier.setAttribute('tabindex', '-1'); premier.focus(); }
    brancher();
    ecran.parentElement.scrollTop = 0;
  }

  function tete(titre, sous) {
    return '<div class="cpt-cible">' + ech(nomDuPlan()) + '</div>' +
           '<h3>' + titre + '</h3>' +
           (sous ? '<p>' + sous + '</p>' : '');
  }

  function option(cle, titre, detail, danger) {
    return '<button type="button" class="cpt-opt' + (danger ? ' danger' : '') + '" data-va="' + cle + '">' +
             '<span class="cpt-o-txt"><b>' + titre + '</b><span>' + detail + '</span></span>' +
             '<span class="cpt-fleche">&rarr;</span>' +
           '</button>';
  }

  function retour(vers) {
    return '<button type="button" class="cpt-retour" data-va="' + vers + '">&larr; Retour</button>';
  }

  var ECRANS = {

    /* Le menu. L'ordre n'est pas cosmetique : le geste le moins couteux est
       en haut, l'annulation tout en bas et en rouge. Un client qui trouve
       « sauter ce passage » avant « annuler » ne cherche pas plus loin. */
    menu: function () {
      var prochain = prochainUtile();
      var stat = (planCourant && planCourant.getAttribute('data-statut')) || '';
      var enPause = (stat === 'pause' || stat === 'en pause');
      return tete('Gérer mon plan',
        prochain ? 'Prochain passage prévu le <b style="color:var(--or-pale)">' + ech(enClair(prochain)) + '</b>. Qu\'est-ce qui vous arrangerait ?'
                 : 'Qu\'est-ce qui vous arrangerait ?') +
        option('sauter', 'Sauter ce passage', 'Ce mois-ci ne fonctionne pas. On reprend au suivant.') +
        option('reporter', 'Changer la date', 'Le passage vous convient, mais pas cette date-là.') +
        (enPause
          ? option('reprendre', 'Reprendre mon plan', 'Vous êtes en pause. On repart quand vous voulez.')
          : option('pause', 'Mettre en pause', 'Vous partez un moment. Rien ne roule pendant ce temps-là.')) +
        option('rythme', 'Changer de rythme', 'Trop souvent, ou pas assez ? Ça se change.') +
        option('annuler', 'Annuler mon plan', 'Vous voulez arrêter pour de bon.', true);
    },

    sauter: function () {
      var prochain = prochainUtile();
      return tete('Sauter un passage',
        prochain ? 'On retire le passage du <b style="color:var(--or-pale)">' + ech(enClair(prochain)) + '</b>. Votre plan reste actif et on reprend au passage suivant.'
                 : 'On retire le prochain passage. Votre plan reste actif.') +
        '<div class="cpt-champ">' +
          '<label for="cptSauterNote">Une précision ? <span style="text-transform:none;letter-spacing:.06em;font-weight:300">(facultatif)</span></label>' +
          '<textarea id="cptSauterNote" placeholder="Ex. : je suis en voyage jusqu\'au 20."></textarea>' +
        '</div>' +
        '<div class="cpt-actions">' +
          '<button type="button" class="btn btn-or" data-envoyer="sauter">Sauter ce passage</button>' +
        '</div>' + retour('menu');
    },

    reporter: function () {
      return tete('Changer la date',
        'Dites-nous ce qui vous arrange. On vous confirme la nouvelle plage par courriel.') +
        '<div class="cpt-champ">' +
          '<label for="cptDate">Nouvelle date souhaitée</label>' +
          '<input type="date" id="cptDate" min="' + dansNJours(1) + '">' +
          '<div class="cpt-aide">On vous propose l\'heure la plus proche disponible ce jour-là.</div>' +
        '</div>' +
        '<div class="cpt-champ">' +
          '<label for="cptPortee">Ça vaut pour</label>' +
          '<select id="cptPortee">' +
            '<option value="ce passage seulement">Ce passage seulement</option>' +
            '<option value="tous les passages suivants">Tous les passages suivants — décalez ma série</option>' +
          '</select>' +
        '</div>' +
        '<div class="cpt-actions">' +
          '<button type="button" class="btn btn-or" data-envoyer="reporter">Demander ce changement</button>' +
        '</div>' + retour('menu');
    },

    pause: function () {
      return tete('Mettre en pause',
        'On arrête votre plan le temps que vous voulez. <b style="color:var(--or-pale)">Votre prix reste figé pendant la pause</b> — vous ne repayez pas le tarif du jour au retour. À la date que vous choisissez, on vous rappelle pour repartir.') +
        '<div class="cpt-champ">' +
          '<label for="cptJusqua">Reprendre le</label>' +
          '<input type="date" id="cptJusqua" min="' + dansNJours(7) + '">' +
          '<div class="cpt-aide">Vous pourrez repartir avant si vous changez d\'idée.</div>' +
        '</div>' +
        '<div class="cpt-champ">' +
          '<label for="cptPauseNote">Pourquoi cette pause ? <span style="text-transform:none;letter-spacing:.06em;font-weight:300">(facultatif)</span></label>' +
          '<textarea id="cptPauseNote" placeholder="Ex. : l\'auto est remisée pour l\'hiver."></textarea>' +
        '</div>' +
        '<div class="cpt-actions">' +
          '<button type="button" class="btn btn-or" data-envoyer="pause">Mettre en pause</button>' +
        '</div>' + retour('menu');
    },

    reprendre: function () {
      return tete('Reprendre mon plan',
        'On vous remet au calendrier. Votre prix figé n\'a pas bougé pendant la pause.') +
        '<div class="cpt-champ">' +
          '<label for="cptReprise">Repartir à partir du</label>' +
          '<input type="date" id="cptReprise" min="' + dansNJours(1) + '">' +
        '</div>' +
        '<div class="cpt-actions">' +
          '<button type="button" class="btn btn-or" data-envoyer="reprendre">Reprendre mon plan</button>' +
        '</div>' + retour('menu');
    },

    /* ⚠️ LES DEUX PRODUITS N'ONT PAS LES MEMES FREQUENCES.
       L'Entretien roule au mois et aux 2 mois ; l'Abonnement, aux 3 et 6 mois.
       La premiere version de cet ecran offrait « aux 2 mois » a tout le monde :
       propose a un abonne aux 6 mois, c'est TROIS FOIS PLUS de passages,
       presente comme un allegement. D'ou `data-genre` sur la carte.
       On ne chiffre rien de plus que ces frequences — elles sont deja
       publiees sur les pages Entretien et Abonnement. */
    rythme: function () {
      var opts = estAbonnement()
        ? '<option value="aux 6 mois">Aux 6 mois plutôt qu\'aux 3 mois</option>' +
          '<option value="aux 3 mois">Aux 3 mois plutôt qu\'aux 6 mois</option>'
        : '<option value="aux 2 mois">Aux 2 mois plutôt que chaque mois</option>' +
          '<option value="chaque mois">Chaque mois plutôt qu\'aux 2 mois</option>';
      return tete('Changer de rythme',
        'Rien ne vous oblige à garder la fréquence de départ. <b style="color:var(--or-pale)">Le tarif par passage se recalcule ensemble</b> avant qu\'on change quoi que ce soit.') +
        '<div class="cpt-champ">' +
          '<label for="cptRythme">Ce qui vous conviendrait</label>' +
          '<select id="cptRythme">' + opts +
            '<option value="autre — voir la précision">Autre — je précise ci-dessous</option>' +
          '</select>' +
        '</div>' +
        '<div class="cpt-champ">' +
          '<label for="cptRythmeNote">Précision <span style="text-transform:none;letter-spacing:.06em;font-weight:300">(facultatif)</span></label>' +
          '<textarea id="cptRythmeNote" placeholder="Ex. : aux 2 mois l\'hiver, chaque mois l\'été."></textarea>' +
        '</div>' +
        '<div class="cpt-actions">' +
          '<button type="button" class="btn btn-or" data-envoyer="rythme">Demander ce rythme</button>' +
        '</div>' + retour('menu');
    },

    /* ---- L'annulation, en deux temps -------------------------------------
       Temps 1 : le motif, obligatoire. Ce n'est pas une formalite — c'est la
       seule donnee qu'on obtient d'un client qui part, et c'est elle qui
       choisit l'offre du temps 2. */
    annuler: function () {
      return tete('Avant de partir',
        'Une question, une seule : <b style="color:var(--or-pale)">qu\'est-ce qui ne va pas ?</b> Selon la réponse, on a peut-être mieux à vous proposer qu\'une annulation.') +
        option('m:prix', 'C\'est trop cher', 'Le montant ne rentre plus dans le budget.') +
        option('m:usage', 'Je ne m\'en sers pas assez', 'Je paie pour des passages que je ne prends pas.') +
        option('m:insatisfait', 'Je ne suis pas satisfait', 'Le résultat n\'est pas à la hauteur.') +
        option('m:vehicule', 'Je change de véhicule', 'Je vends, ou j\'en achète un autre.') +
        option('m:demenage', 'Je déménage', 'Je pars trop loin de Lévis.') +
        option('m:moimeme', 'Je le fais moi-même', 'Je m\'en occupe désormais.') +
        option('m:autre', 'Autre raison', 'Je vous explique.') +
        retour('menu');
    },

    /* Temps 2 : l'offre qui repond au motif. Voir `sauvetagePour` plus bas. */
    sauvetage: function () {
      var s = sauvetagePour(motifChoisi);
      var h = tete(s.titre, s.intro);
      if (s.offre) {
        h += '<div class="cpt-sauve">' +
               '<div class="cpt-etiq">' + s.offre.etiq + '</div>' +
               '<p>' + s.offre.texte + '</p>' +
               '<button type="button" class="btn btn-or" style="width:100%;justify-content:center" data-envoyer="' + s.offre.envoi + '" data-requis="' + (s.detailRequis ? '1' : '0') + '">' + s.offre.bouton + '</button>' +
             '</div>';
      }
      h += '<div class="cpt-champ">' +
             '<label for="cptMotifDetail">' + (s.detailRequis ? 'Dites-nous-en un peu plus' : 'Quelque chose à ajouter ?') +
             (s.detailRequis ? '' : ' <span style="text-transform:none;letter-spacing:.06em;font-weight:300">(facultatif)</span>') + '</label>' +
             '<textarea id="cptMotifDetail" placeholder="' + ech(s.exemple || '') + '"></textarea>' +
             (s.detailRequis ? '<div class="cpt-aide">Obligatoire — c\'est ce qui nous permet de corriger le tir.</div>' : '') +
           '</div>' +
           '<div class="cpt-erreur" id="cptErr" hidden></div>' +
           '<div class="cpt-actions">' +
             '<button type="button" class="btn btn-ghost" data-envoyer="annuler" data-requis="' + (s.detailRequis ? '1' : '0') + '">' +
               (s.offre ? 'Non merci, annuler quand même' : 'Confirmer l\'annulation') +
             '</button>' +
           '</div>' + retour('annuler');
    }
  };

  /* ---- Les sauvetages : un motif, une reponse. ------------------------
     ⚠️ CE BLOC EST UNE FONCTION, PAS UNE TABLE — et pour deux raisons.
     1. Les frequences dependent du produit : « aux 2 mois » pour l'Entretien,
        « aux 6 mois » pour l'Abonnement. Une table figee offrait la meme phrase
        aux deux, donc une AUGMENTATION de frequence presentee comme une
        economie a la moitie des clients.
     2. RIEN ICI N'INVENTE UN ENGAGEMENT. La premiere version promettait une
        reprise gratuite du vehicule et un transfert de plan sur une autre auto :
        ni l'une ni l'autre n'est ecrite ailleurs sur le site, et c'est le client
        le plus motive a s'en prevaloir qui les lisait. Ce qu'on offre ici est
        soit un rythme qui existe deja, soit une pause, soit un appel. Le seul
        chiffre autorise est une frequence deja publiee.
     ET AUCUN MONTANT. Espacer les passages ne baisse PAS le prix unitaire — il
     monte (60 $ au mois contre 80 $ aux 2 mois cote Entretien). Ce qui baisse,
     c'est la facture annuelle. Le site le dit deja : « on refait le calcul
     ensemble, a ce moment-la ». On tient la meme ligne. */
  function sauvetagePour(motif) {
    var esp = plusEspace();           // « aux 2 mois » ou « aux 6 mois »
    var courant = estAbonnement() ? 'aux 3 mois' : 'chaque mois';

    var T = {
      'm:prix': {
        titre: 'Payer moins, sans arrêter',
        intro: 'Avant d\'annuler : la facture de l\'année baisse si les passages s\'espacent.',
        offre: {
          etiq: 'Ce qu\'on peut faire',
          texte: 'Passer <b>' + esp + '</b> plutôt que ' + courant + ' : moitié moins de visites dans l\'année. <b>On refait le calcul du tarif avec vous</b> avant de changer quoi que ce soit.',
          bouton: 'Voir pour ' + esp,
          envoi: 'sauvetage-rythme'
        },
        exemple: 'Ex. : ce serait correct à tel montant par mois.'
      },
      'm:usage': {
        titre: 'Ne payez pas pour rien',
        intro: 'Si vous ne prenez pas vos passages, le problème est la fréquence, pas le service.',
        offre: {
          etiq: 'Deux options',
          texte: 'Soit on <b>espace ' + esp + '</b>, soit on <b>met en pause</b> jusqu\'à ce que vous en ayez besoin. La pause garde votre prix figé ; si on espace, on refait le calcul avec vous avant.',
          bouton: 'Espacer plutôt qu\'annuler',
          envoi: 'sauvetage-rythme'
        },
        exemple: 'Ex. : je fais peu de kilométrage l\'hiver.'
      },
      'm:insatisfait': {
        titre: 'On veut le savoir',
        intro: 'Si le résultat n\'est pas à la hauteur, on ne veut pas que vous partiez là-dessus.',
        offre: {
          etiq: 'Ce qu\'on fait dans ce cas-là',
          texte: '<b>Alex ou Oli vous rappelle</b> et regarde le véhicule avec vous. On veut d\'abord comprendre ce qui n\'a pas marché.',
          bouton: 'Qu\'on me rappelle',
          envoi: 'sauvetage-rappel'
        },
        exemple: 'Qu\'est-ce qui n\'allait pas ? Soyez direct — c\'est utile.'
      },
      'm:vehicule': {
        titre: 'Avant de tout arrêter',
        intro: 'Changer d\'auto n\'oblige pas forcément à annuler.',
        offre: {
          etiq: 'Ce qu\'on peut regarder',
          texte: 'Dites-nous quel véhicule vous prenez — <b>on regarde ce qu\'on peut faire avec votre plan</b> et on vous revient. Le format du véhicule change la durée à l\'atelier, donc le prix : on vous le dit avant.',
          bouton: 'Nous en parler',
          envoi: 'sauvetage-transfert'
        },
        exemple: 'Quel véhicule prenez-vous ? Marque, modèle, année.'
      },
      'm:demenage': {
        titre: 'Bonne route',
        intro: 'On ne va pas essayer de vous retenir : si vous partez trop loin de Lévis, un plan ne vous sert à rien. On arrête ça proprement.',
        offre: null,
        exemple: 'Ex. : je pars le 1er septembre. (Facultatif)'
      },
      'm:moimeme': {
        titre: 'Respect',
        intro: 'Faire son auto soi-même, on comprend ça mieux que personne.',
        offre: {
          etiq: 'Une idée avant de partir',
          texte: 'Beaucoup gardent un passage <b>' + esp + '</b> pour ce qui est long et salissant — l\'intérieur en profondeur, la décontamination — et font l\'entretien courant eux-mêmes.',
          bouton: 'Garder un passage ' + esp,
          envoi: 'sauvetage-rythme'
        },
        exemple: 'Ex. : je me suis équipé cet été.'
      },
      'm:autre': {
        titre: 'Dites-nous pourquoi',
        intro: 'On annule sans discuter. Mais on aimerait comprendre — c\'est comme ça qu\'on s\'améliore.',
        offre: null,
        /* SEUL cas ou le texte est exige : « Autre » sans un mot ne dit rien, et
           le motif est justement la seule chose qu'on demande a un client qui
           part. Partout ailleurs la tuile cliquee porte deja le motif — exiger
           en plus un paragraphe serait un obstacle a la resiliation, que le site
           interdit lui-meme (« aucun engagement, aucuns frais, aucun preavis »). */
        detailRequis: true,
        exemple: 'Votre raison, en une ligne.'
      }
    };
    return T[motif] || T['m:autre'];
  }

  /* ---- Branchement des boutons de l'ecran courant ---------------------- */

  function brancher() {
    ecran.querySelectorAll('[data-va]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cible = b.getAttribute('data-va');
        if (cible.indexOf('m:') === 0) { motifChoisi = cible; montrer('sauvetage'); return; }
        montrer(cible);
      });
    });
    ecran.querySelectorAll('[data-envoyer]').forEach(function (b) {
      b.addEventListener('click', function () { envoyer(b.getAttribute('data-envoyer'), b); });
    });
  }

  /* ---- L'envoi --------------------------------------------------------
     On construit un courriel qu'un humain peut executer sans rien deviner :
     quel client, quel plan, quelle demande, et le detail. Le `gid` du plan
     est la parce que sans lui, « mets mon plan en pause » ne designe rien
     des qu'un client en tient deux.                                       */

  function valeur(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  var LIBELLES = {
    'sauter': 'Sauter le prochain passage',
    'reporter': 'Changer la date d\'un passage',
    'pause': 'Mettre le plan en pause',
    'reprendre': 'Reprendre le plan',
    'rythme': 'Changer de rythme',
    'annuler': 'ANNULATION',
    'sauvetage-rythme': 'Espacer les passages (RETENU avant annulation)',
    'sauvetage-rappel': 'Demande de rappel — insatisfaction (RETENU)',
    'sauvetage-transfert': 'Changement de véhicule — à regarder (RETENU)'
  };

  var MOTIFS_CLAIRS = {
    'm:prix': 'Trop cher',
    'm:usage': 'Ne s\'en sert pas assez',
    'm:insatisfait': 'Insatisfait du résultat',
    'm:vehicule': 'Change de véhicule',
    'm:demenage': 'Déménage',
    'm:moimeme': 'Le fait lui-même',
    'm:autre': 'Autre'
  };

  /* Un envoi part une seule fois. Sans ce drapeau, l'ecran de sauvetage —
     le seul a porter DEUX boutons d'envoi — laissait partir « offre acceptee »
     puis « ANNULATION » sur un double clic pendant la navigation : l'atelier
     recevait deux courriels contradictoires sur le meme plan, a la seconde. */
  var envoiEnCours = false;

  function envoyer(type, bouton) {
    if (!form || envoiEnCours) return;
    var lignes = [];
    var detail = '';

    if (type === 'sauter') {
      detail = valeur('cptSauterNote');
      lignes.push('Passage à retirer : ' + (prochainUtile() || 'le prochain — la date au dossier est passée'));
    } else if (type === 'reporter') {
      var d = valeur('cptDate');
      if (!d) return erreurLocale(bouton, 'Choisissez une date.');
      lignes.push('Nouvelle date souhaitée : ' + d);
      lignes.push('Portée : ' + valeur('cptPortee'));
    } else if (type === 'pause') {
      var j = valeur('cptJusqua');
      if (!j) return erreurLocale(bouton, 'Choisissez la date de reprise.');
      lignes.push('Pause jusqu\'au : ' + j);
      detail = valeur('cptPauseNote');
    } else if (type === 'reprendre') {
      var r = valeur('cptReprise');
      if (!r) return erreurLocale(bouton, 'Choisissez la date de reprise.');
      lignes.push('Reprise à partir du : ' + r);
    } else if (type === 'rythme') {
      lignes.push('Rythme souhaité : ' + valeur('cptRythme'));
      detail = valeur('cptRythmeNote');
    } else {
      // annulation et sauvetages : tous partis de l'ecran motif
      detail = valeur('cptMotifDetail');
      lignes.push('Motif donné : ' + (MOTIFS_CLAIRS[motifChoisi] || 'non précisé'));
      if (type === 'annuler') {
        var requis = bouton.getAttribute('data-requis') === '1';
        if (requis && !detail) {
          var err = document.getElementById('cptErr');
          if (err) { err.textContent = 'Un mot d\'explication, s\'il vous plaît — c\'est la seule chose qu\'on demande.'; err.hidden = false; }
          var champ = document.getElementById('cptMotifDetail');
          if (champ) champ.focus();
          return;
        }
        lignes.push('>>> LE CLIENT A REFUSÉ L\'OFFRE DE RÉTENTION ET DEMANDE L\'ANNULATION.');
      } else {
        lignes.push('>>> Offre de rétention ACCEPTÉE — le client reste.');
      }
    }

    var corps = [
      'Demande envoyée depuis /pages/compte',
      '',
      'DEMANDE : ' + (LIBELLES[type] || type),
      'Plan : ' + nomDuPlan(),
      'Rythme actuel : ' + (planCourant.getAttribute('data-rythme') || '—'),
      'Statut actuel : ' + (planCourant.getAttribute('data-statut') || '—'),
      'Identifiant du plan : ' + (planCourant.getAttribute('data-gid') || '—'),
      ''
    ].concat(lignes);

    if (detail) { corps.push(''); corps.push('Le client écrit :'); corps.push(detail); }

    document.getElementById('cptFType').value = LIBELLES[type] || type;
    document.getElementById('cptFPlan').value = nomDuPlan() + ' — ' + (planCourant.getAttribute('data-gid') || '');
    document.getElementById('cptFBody').value = corps.join('\n');

    envoiEnCours = true;
    ecran.querySelectorAll('[data-envoyer],[data-va]').forEach(function (b) { b.disabled = true; });
    bouton.textContent = 'Envoi…';
    form.submit();
  }

  function erreurLocale(bouton, texte) {
    var d = document.createElement('div');
    d.className = 'cpt-erreur';
    d.textContent = texte;
    var deja = bouton.parentElement.previousElementSibling;
    if (deja && deja.classList.contains('cpt-erreur')) deja.remove();
    bouton.parentElement.parentElement.insertBefore(d, bouton.parentElement);
  }

  /* ---- La revelation au defilement -------------------------------------
     v2.js observe les `.rv` presents au chargement. Les cartes de cette page
     le sont toutes (rendues en Liquid), donc rien a refaire ici — mais si
     l'observateur n'a pas tourne, une carte resterait invisible a jamais.
     Ce filet la rend visible apres 1,2 s quoi qu'il arrive.               */
  window.setTimeout(function () {
    document.querySelectorAll('.cpt .rv:not(.vu)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('vu');
    });
  }, 1200);
})();
